// Dossiê temático de cada Serviço Sujo (os números vêm sempre do config da Season)
export const SVC_LORE = {
  industrial_espionage: {
    tag: 'INTELIGÊNCIA · NÃO É ATAQUE',
    lore: 'Um contador subornado abre os livros do alvo numa mesa de sinuca nos fundos do porto. '
      + 'Ninguém quebra nada — você só descobre onde o dinheiro dele dorme.',
    extra: [
      'Você recebe o dossiê na hora: FOX Dólar exato, Black Coins, gotas de petróleo, nível da usina e da envasadora, posição no ranking e se ele tem escudo ativo.',
      'O alvo NUNCA fica sabendo: espionagem não acende alerta nos Informantes dele.',
      'Não causa dano, não deixa o alvo imune e não gasta nenhuma das suas operações ofensivas do dia.',
    ],
  },
  cargo_interception: {
    tag: 'GOLPE LEVE · BARATO E RÁPIDO',
    lore: 'Dois caminhões-tanque saem da refinaria do alvo e nunca chegam ao porto. '
      + 'A carga desaparece nas docas antes do amanhecer e ninguém viu nada.',
  },
  pipeline_leak: {
    tag: 'SABOTAGEM SILENCIOSA',
    lore: 'Uma válvula "esquecida" aberta na madrugada. O oleoduto do alvo sangra petróleo no '
      + 'mangue a noite inteira e a produção dele vira prejuízo puro.',
  },
  refinery_sabotage: {
    tag: 'SABOTAGEM PESADA',
    lore: 'Um engenheiro comprado troca a peça errada de propósito. A refinaria do alvo para no '
      + 'meio do turno e o barril fica encalhado no pátio.',
  },
  platform_incident: {
    tag: 'OPERAÇÃO DE ALTO IMPACTO',
    lore: 'Um "acidente" na plataforma do alvo: cabo rompido, torre parada, jornalistas na área. '
      + 'Prejuízo grande e manchete no dia seguinte.',
  },
  clandestine_market_move: {
    tag: 'GOLPE DE COLARINHO BRANCO',
    lore: 'Você paga corretores para despejar o barril do alvo no mercado paralelo. O preço afunda '
      + 'e o império dele perde uma fortuna sem ninguém encostar um dedo.',
  },
  fox_exchange_vault_heist: {
    tag: 'O GOLPE DO SÉCULO',
    lore: 'O serviço mais caro da Terra dos Mafiosos: entrar no cofre da Bolsa FOX e queimar a '
      + 'papelada do alvo. Poucos tentam, menos ainda voltam para contar.',
  },
};

export const pct = (v) => `${Math.round(Number(v || 0) * 100)}%`;

// Vídeo de efeito exibido quando a operação dá certo (webm + mp4 por compatibilidade)
export const SVC_VIDEO = {
  cargo_interception: { success: '/oil/video/cargo_interception', fail: '/oil/video/cargo_interception_fail' },
  industrial_espionage: { success: '/oil/video/espionage_success', fail: '/oil/video/espionage_fail' },
  pipeline_leak: { success: '/oil/video/pipeline_leak_success', fail: '/oil/video/pipeline_leak_fail' },
  refinery_sabotage: { success: '/oil/video/refinery_sabotage_success', fail: '/oil/video/refinery_sabotage_fail' },
  platform_incident: { success: '/oil/video/platform_incident_success', fail: '/oil/video/platform_incident_fail' },
  clandestine_market_move: { success: '/oil/video/clandestine_market_move_success', fail: '/oil/video/clandestine_market_move_fail' },
  fox_exchange_vault_heist: { success: '/oil/video/fox_exchange_vault_heist_success', fail: '/oil/video/fox_exchange_vault_heist_fail' },
};
